<template>
    <section class="my-14">
        <div class="container px-11 2xl:px-3 m-auto">
            <div class="q10__article_container__title_head">
                <!-- article title head -->
                <article-title-head
                    :options="{
                        category: currentPage.content.oTitleHead_sCategory.text,
                        phrase: currentPage.content.oTitleHead_sPhrase.text,
                        author: currentPage.content.oTitleHead_sAuthor.text,
                        from: currentPage.content.oTitleHead_nFrom.text,
                        to: currentPage.content.oTitleHead_nTo.text,
                        color: 'text-sushi',
                    }"
                ></article-title-head>
            </div>

            <div class="q10__article_container__content">
                <div
                    class="
                        q10__article_container__content__vertical_head
                        mx-auto
                        relative
                    "
                >
                    <div class="relative">
                        <article-vertical-head
                            :options="{
                                text: currentPage.content.oVerticalHead_sText
                                    .text,
                                position: 'lg:ml-2',
                                imageAuthor:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image_001.src,
                            }"
                        ></article-vertical-head>

                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Interview de Y. Baros'
                                ),
                            }"
                            class="top-6 right-1 lg:right-6"
                        />
                    </div>
                </div>

                <div class="q10__article_container__content__paragraphs">
                    <paragraph-first-letter-big
                        :options="{
                            letter: currentPage.content.firstParagraph.text.substr(
                                0,
                                1
                            ),
                            color: 'text-sushi',
                        }"
                    />

                    <paragraph :options="{}"> 
                        <span
                            v-html="
                                currentPage.content.firstParagraph.text.slice(1)
                            "
                        ></span>
                        <!-- <Square
                            :options="{
                                from: 'from-feijoa',
                                to: 'to-sushi',
                            }"
                        /> -->
                    </paragraph>
                </div>
            </div>
        </div>

        <timeline-carousel
            :options="{
                timeline: currentPage.timeline,
            }"
        />

        <div class="container px-11 2xl:px-3  m-auto">
            <div class="relative">
                <hotspot-richmedia
                        :options="{
                            icon: 'diaporama',
                            collection: getRichmediaByCollection(
                                currentPage,
                                'La STEP d’Hatta concrétise les ambitions de Dubaï'
                            ),
                        }"
                        class="bottom-2 left-2.5 lg:left-1.5"
                    /> 
                <image-with-descriptions
                    :options="{
                        image:
                            'pages/' +
                            currentPage.slug +
                            '/' +
                            currentPage.images.image_002.src,
                        descriptions: [
                            {
                                text: currentPage.images.image_002.text,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: currentPage.images.image_002.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                        ],
                    }"
                />

               
            </div>

            <div class="relative  flex flex-col lg:flex-row w-full">
            <article-note class="md:w-full"
                :options="{
                    verticalcontent: currentPage.content.verticalContent.text,
                    title: currentPage.content.sTitle.text,
                    content: currentPage.content.secondParagraph.text,
                    color: {
                        verticalcontent: 'text-cornflower_blue',
                        title: 'text-selective_green',
                        content: 'text-nandor',
                    },
                    fontSize: {
                        verticalcontent: 'text-4xl md:text-3xl lg:text-4xl',
                        title: 'text-4xl md:text-3xl lg:text-4xl',
                        content: 'text-md md:text-xl lg:text-xl',
                    },
                    margin: {
                        verticalcontent: 'mt-1',
                    },
                }"
            />
             <!-- <div class="customImageGratarCuBaietii w-full md:w-2/4 lg:w-1/4 ml-12 "> -->
                <div class="customFixWidth relative my-auto pl-5">
                <hotspot-richmedia
                    :options="{
                        icon: 'diaporama',
                        collection: getRichmediaByCollection(
                            currentPage,
                            'Retour sur le Suntrip 2019'
                        ),
                    }"
                    class="top-2 right-2"
                />
                <image-with-descriptions 
                
                    :options="{
                        image:
                            'pages/' +
                            currentPage.slug +
                            '/' +
                            currentPage.images.image_003.src,
                        descriptions: [
                            {
                                text: currentPage.images.image_003.text,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                                fontSize: 'text-xs md:text-base',
                            },
                        ],
                    }"
                    
                />
                </div>
                
               
            </div>

        </div>
    </section>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";

export default {
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.article_note {
    @apply overflow-visible;
}

.q10__article_container {
    &__title_head {
        @apply lg:-mb-5;
    }

    &__content {
        @apply flex flex-col lg:flex-row justify-center;

        &__vertical_head {
            @apply col-auto;
        }

        &__paragraphs {
            @apply col-auto mt-3;
        }
    }
}

    .customImageGratarCuBaietii{
            display: inline-block;
            position: relative;
            @media screen and (max-width: 1921px) {
                left: 50%;
                margin-top: -55px;
            }
            @media screen and (max-width: 1441px) {
                left: 10%;
            }
            @media screen and (max-width: 1281px) {
                left: 10%;
            }
            @media screen and (max-width: 1181px) {
                left: 20%;
            }
            @media screen and (max-width: 1025px) {
                left: 20%;
            }
            @media screen and (max-width: 1025px) {
                left: 20%;
                padding-top: 2rem;
            }
            @media screen and (max-width: 768px) {
                display: contents;
            }
                
        }
    .customFixWidth{
        width: 100%;
        @media screen and (min-width: 1024px) {
            width: 40%;
        }
    }
</style>
